import { createContext, useContext } from "react";
import invariant from "tiny-invariant";

export interface ContentProps {
  alert: string;
  hasMinimalLayout: boolean;
  notice: string;
  shouldDisplayCommunitySwitcher: boolean;
  shouldDisplayHeader: boolean;
}

const ContentPropsContext = createContext<ContentProps | undefined>(undefined);

ContentPropsContext.displayName = "ContentPropsContext";

export const ContentPropsProvider = ({
  children,
  contentProps,
}: {
  children: React.ReactNode;
  contentProps: ContentProps;
}) => (
  <ContentPropsContext.Provider value={contentProps}>
    {children}
  </ContentPropsContext.Provider>
);

export const useContentProps = () => {
  const context = useContext(ContentPropsContext);
  invariant(
    context,
    "useContentProps must be used within a ContentPropsProvider",
  );
  return context;
};
